// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'
import router from './router'
import messages from './locale/message'

Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(ElementUI)

let lang = localStorage.getItem('lang') || 'es'

const i18n = new VueI18n({
  locale: lang, // set locale
  messages, // set locale messages
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  i18n,
})



// WEBPACK FOOTER //
// ./src/main.js